import store from '@/store'

function checkPermission(el, binding) {
    const { value } = binding

    if (value) {
        const ptzControl = store.getters && store.getters.ptzControl

        const hasPermission = ptzControl.includes(value)

        if (!hasPermission) {
            el.parentNode && el.parentNode.removeChild(el)
        }
    } else {
        throw new Error(`need roles! Like v-ptz-control="['query','add']"`)
    }
}

export default {
    inserted(el, binding) {
        checkPermission(el, binding)
    },
    update(el, binding) {
        checkPermission(el, binding)
    }
}
